import React from 'react'
import { Route, RouteComponentProps } from 'react-router-dom'

import Activities from '../Activities/Activitites'
import ActivityOutcomesLanding from '../ActivityOutcomesLanding/ActivityOutcomesLanding'
import ParticipantLanding from '../ParticipantLanding/ParticipantLanding'
import ParticipantOutcomesLanding from '../ParticipantOutcomesLanding/ParticipantOutcomesLanding'
import SingleActivity from '../SingleActivity/SingleActivity'

export type RouterProps = {} & RouteComponentProps<{}>

const ActivitiesLanding: React.FC<RouterProps> = (props: RouterProps) => {
	const { match } = props

	return (
		<div data-auto="activities-content-wrapper">
			<Route exact={true} path={match.url} component={Activities} />
			<Route exact={true} path={`${match.url}activities/:activityID`} component={SingleActivity} />
			<Route exact={true} path={`${match.url}activities/:activityID/outcome`} component={ActivityOutcomesLanding} />
			<Route
				exact={true}
				path={`${match.url}activities/:activityID/participants/:participantID`}
				component={ParticipantLanding}
			/>
			<Route
				exact={true}
				path={`${match.url}activities/:activityID/participants/:participantID/outcomes`}
				component={ParticipantOutcomesLanding}
			/>
		</div>
	)
}

export default ActivitiesLanding
